import ArtistSongsHead from './Head';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getCurrentArtistId,
  getCurrentArtistName,
  getSongDirectoryPath,
} from 'state/Artists/selectors';
import { getSiteUrl } from 'state/Config/selectors';

const mapStateToProps = createStructuredSelector({
  artistId: getCurrentArtistId,
  artistName: getCurrentArtistName,
  pagePath: getSongDirectoryPath,
  siteUrl: getSiteUrl,
});

export default connect(mapStateToProps)(ArtistSongsHead);
